var exports = {
  "k": "x4ddf2309--1aefc1--container",
  "D": "x4ddf2309--1aefc1--title",
};

module.exports = exports;
